import { grey, text } from "colors";

export const styles = {
  section: {
    overflow: "hidden",
    position: "relative",
    maxWidth: "970px",
    background: "#fff",
    margin: "0px auto 70px auto",
    "@media (max-width: 1000px)": {
      width: "100%",
      padding: "0 12px",
      margin: "0 auto",
    },
  },
  block: {
    display: "flex",
    alignItems: "end",
    marginBottom: "10px",
    position: "relative",
    "@media (max-width: 800px)": {
      display: "none",
    },
  },
  resumeTitle: {
    position: "absolute",
    top: "10px",
    zIndex: "2",
    background: " rgba(255, 255, 255, 0.7)",
    borderRadius: "0px 3px 3px 0px",
    padding: "5px 15px",
    fontSize: "16px",
    fontWeight: "400",
    "@media (min-width: 801px)": {
      display: "none",
    },
  },
  container: {
    display: "flex",
    position: "relative",
    border: "1px solid #ccc",
    "@media (max-width: 800px)": {
      flexDirection: "column",
      border: "none",
    },
  },
  imageBox: {
    position: "relative",
    width: "100%",
    height: "400px",
    background: `${grey}`,
    marginBottom: "30px",
    "@media (min-width: 800px)": {
      marginTop: "13px",
    },
  },
  ownInfo: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "end",
    marginBottom: "28px",
    padding: "0 10px",
    "@media (max-width: 800px)": {
      display: "none",
    },
  },
  infoBlock: {
    width: "calc(100% - 80px)",
    position: "absolute",
    bottom: "0px",
    background: "rgba(0, 0, 0, 0.5)",
    "@media (min-width: 800px)": {
      display: "none",
    },
  },
  innerInfoBlock: {
    "@media (max-width: 800px)": {
      padding: "0 16px",
      width: "inherit",
    },
  },
  detailInfo: {
    "@media (max-width: 801px)": {
      padding: "0 16px",
    },
  },

  selfIntroduction: {
    "@media (min-width: 801px)": {
      paddingTop: "13px",
      maxWidth: "300px",
      width: "100%",
      borderRight: "1px solid #ccc",
      padding: "0 16px",
    },
  },
  fields: {
    padding: "16px",
    width: "calc(100% - 16px)",
    "@media (max-width: 800px)": {
      paddingTop: "20px",
      width: "calc(100% - 32px)",
      borderTop: `1px solid ${grey}`,
    },
  },
  qrBox: {
    width: "150px",
    height: "150px",
    display: "block",
    margin: "62px auto",
    "@media (max-width: 800px)": {
      position: "absolute",
      top: "16px",
      right: "16px",
      width: "30px",
      height: "30px",
      margin: "0",
    },
  },
  qrCode: {
    width: "100%",
    height: "100%",
  },
  title: {
    marginBottom: "12px",
    textTransform: "uppercase",
    fontSize: "12px",
    lineHeight: "14px",
    color: `${text}`,
  },
  text: {
    marginBottom: "18px",
  },
  output: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyItems: "start",
    border: "1px solid #29CC8F",
    borderRadius: "31px",
    height: "40px",
    marginRight: "10px",
    marginBottom: "22px",
    padding: "0 8px",
  },
  textarea: {
    border: "1px solid #29CC8F",
    borderRadius: "4px",
    width: "calc(100% - 32px)",
    height: "fit-content",
    padding: "10px",
    marginBottom: "24px",
    background: "white",
    fontSize: "14px",
    fontWeight: "400",
  },
  files: {
    border: "1px solid #29CC8F",
    width: "132px",
    height: "164px",
    color: "#29CC8F",
    borderRadius: "4px",
    position: "relative",
  },
  uploadImage: {
    position: "absolute",
    bottom: "0",
    right: "0",
  },
  fileName: {
    fontFamily: "Roboto-Medium",
    fontSize: "12px",
    fontWeight: 500,
    wordBreak: "break-word",
    textAlign: "center",
    width: "85%",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  box: {
    position: "relative",
    marginRight: "20px",
    marginBottom: "20px",
  },
  scrollButton: {
    display: "flex",
    justifyContent: "end",
    marginTop: "30px",

    "@media (min-width: 801px)": {
      display: "none",
    },
  },
};
